<template>
  <div class="inners">
    <div class="right">
      <div class="titles">
        {{ $t('userinfo.vip.AI') }}
        {{ $t('common.details') }}
      </div>
      <indexAI></indexAI>
      <div>
        <div class="results">
          <div class="buttons_pays" v-if="!isEnterpriseChildUser" @click="handleClickBuy">
            {{ $t('AI.buy.number') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Echarts from "@/views/UserCenter/StoreDetails/Echarts.vue";
import {useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {spaceSizeFormat} from "@/utils/file";
import indexAI from "./component/indexAI.vue"

const router = useRouter()
const store = useStore()

// 所有产品包
const allProductList = computed(() => store.state.buystorage.allProductList)
// 判断是否为企业子账号
const isEnterpriseChildUser = computed(() => store.getters['user/isEnterpriseChildUser'])

const handleClickBuy = () => {
  const findTarget = allProductList.value.find(item => item.productSort === 4)
  console.log(allProductList.value, findTarget, 'allProductList')
  const {id, productSort} = findTarget
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: 1}})
}

onMounted(async () => {
  try {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  } catch (e) {

  }
})


</script>

<style lang="less" scoped>
@import "../less/Tables.less";
@import "../../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;
  position: relative;
}

.right {
  height: auto !important;
  min-height: 640px !important;
  padding-bottom: 70px !important;
}

.inner_box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  .left_box {
    width: 380px;
    min-width: 380px;

    div {
      margin-bottom: 10px;
    }
  }

  .right_box {
    flex: 1 1;
  }
}

.line_title {
  display: inline-block;
  width: 126px;
  color: #999;
}

.txt {
  display: inline-block;
  color: #333;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}
</style>
